<template>
  <div>
    <!-- search -->
    <div class="table-page-search-wrapper">
      <a-form>
        <a-row :gutter="48">
          <a-col :md="20" style="display:flex">
            <a-form-item label="名称">
              <a-input placeholder="请输入菜谱名称" v-model="search.name" />
            </a-form-item>

            <a-form-item label="就餐类型" style="margin-left:20px;">
              <a-select :value="search.type" @change="handleSearchTypeChange">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="1">早餐</a-select-option>
                <a-select-option value="2">午餐</a-select-option>
                <a-select-option value="3">晚餐</a-select-option>
              </a-select>
            </a-form-item>
            <a-button
              class="sm"
              style="margin-left:20px;margin-top: 4px;"
              @click="resetSearch"
            >
              重置</a-button
            >
            <a-button
              class="sm"
              type="primary"
              style="margin-left:20px;margin-top: 4px;"
              @click="searchTable"
            >
              <a-icon type="search" />查询</a-button
            >
          </a-col>
          <a-col :md="4">
            <a-button
              type="primary"
              style="float: right;"
              @click="showAddModal('add')"
            >
              <a-icon type="plus" />新增
            </a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 列表 -->
    <a-list
      class="menuListContent"
      :grid="{ gutter: 16, column: 6 }"
      :dataSource="menuList"
      :pagination="pagination"
      :loading="listLoading"
    >
      <a-list-item slot="renderItem" slot-scope="item">
        <a-card hoverable style="width:100%;">
          <div class="itemImgContent">
            <img
              :alt="item.name"
              :title="item.name"
              style="width:100%;"
              :src="item.imgUrl ? item.imgUrl : 'images/noImg.jpg'"
              onerror="this.src='images/noImg.jpg'"
              slot="cover"
            />
            <span class="itemTag" v-if="item.menuEatType !== null">
              <span
                v-for="(c_Item, c_Index) in item.menuEatType.split(',').sort()"
                :key="c_Index"
              >
                {{ c_Item === "1" ? "早餐" : c_Item === "2" ? "午餐" : "晚餐" }}
                <br />
              </span>
            </span>
          </div>
          <template class="ant-card-actions" slot="actions">
            <a-icon
              type="edit"
              title="修改菜谱"
              @click="showAddModal('edit', item)"
            />
            <a-icon
              type="ordered-list"
              title="食材管理"
              @click="menuFoodOpen(item)"
              :style="{
                color: item.isFoodComponent ? '#1890ff' : 'rgba(0, 0, 0, 0.45)'
              }"
            />
            <a-icon
              type="delete"
              title="删除菜谱"
              @click="_delItemMenu(item.id)"
            />
          </template>
          <a-card-meta>
            <a slot="title">{{ item.name }}</a>
          </a-card-meta>
        </a-card>
      </a-list-item>
    </a-list>

    <!-- modal -->
    <add-menu-modal
      :show-modal="showAddModalFlag"
      @cancel="handleCancel"
      @submit="handleSubmit"
      :menuTypeList="menuTypeList"
      :confirmLoading="confirmLoading"
      :addInfo="addMenuModelInfo"
      :submitType="submitType"
    >
    </add-menu-modal>
    <!-- menuFoodDrawer -->
    <menu-food-drawer
      :menuId="menuId"
      :drawerVisibleFlag="drawerVisibleFlag"
      :isFoodComponent="isFoodComponent"
      :isNutrion="isNutrion"
      @rightDrawSubmit="rightDrawSubmit"
      @close="menuFoodClose"
    >
    </menu-food-drawer>
  </div>
</template>

<script>
import addMenuModal from '@/components/menu-manage/add-edit-menu-tpl'
import menuFoodDrawer from '@/components/menu-manage/menu-food-right-drawer'
import { getMenuList, addMenu, editMenu, delMenu, getMenuType } from '@/apis/menu'

export default {
  data() {
    return {
      menuList: [],
      search: {
        name: '',
        type: ''
      },
      addMenuModelInfo: {
        name: '',
        imgUrl: ''
      },
      submitType: 'add',
      showAddModalFlag: false,
      listLoading: false,
      confirmLoading: false,
      pagination: {
        onChange: (page, pageSize) => {
          this.pagination.current = page
          this.pagination.pageSize = pageSize
          this._getMenuList()
        },
        total: 0,
        pageSize: 12,
        current: 1,
        showTotal: total => `共 ${total} 条`,
        pageSizeOptions: ['12', '24', '36', '48'],
        defaultPageSize: 12,
        showQuickJumper: true,
        showSizeChanger: true,
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this._getMenuList()
        }
      },
      // 右侧抽屉属性
      drawerVisibleFlag: false,
      menuId: 0,
      isFoodComponent: false,
      isNutrion: true,
      menuTypeList: []
    }
  },
  props: {
    tabIndex: String
  },
  methods: {
    _getMenuType() {
      getMenuType().then(res => {
        if (res.data.state === 1) {
          this.menuTypeList = res.data.attribute
        }
      })
    },
    handleSearchTypeChange(value) {
      this.search.type = value
    },
    // 打开右侧抽屉
    menuFoodOpen(item) {
      this.menuId = item.id
      this.isNutrion = item.label.includes('营养')
      this.isFoodComponent = item.isFoodComponent
      this.drawerVisibleFlag = true
    },
    // 关闭右侧抽屉
    menuFoodClose() {
      this.drawerVisibleFlag = false
      this.isFoodComponent = false
    },
    rightDrawSubmit() {
      this.menuFoodClose()
      this._getMenuList()
    },
    // reset
    resetSearch() {
      this.search = {
        name: '',
        type: ''
      }
    },
    searchTable() {
      this.pagination.current = 1
      this._getMenuList()
    },
    // 获取菜谱列表
    _getMenuList() {
      this.listLoading = true
      getMenuList({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        name: this.search.name,
        type: this.search.type
      }).then((res) => {
        this.listLoading = false
        if (res.data.state === 1) {
          if (res.data.attribute.rows.length) {
            this.menuList = res.data.attribute.rows
            this.pagination.total = res.data.attribute.pageCount
          }
        }
      }, res => {
        this.listLoading = false
      });
    },
    // 删除菜谱
    _delItemMenu(id) {
      let that = this
      let formData = new FormData()
      formData.append('id', id)
      that.$confirm({
        title: '您确定要删除该菜谱吗?',
        content: '删除后将不可撤销',
        onOk() {
          delMenu(formData).then(res => {
            if (res.data.state === 1) {
              that.$message.success('删除成功');
              that.pagination.current = 1
              that._getMenuList()
            }
          });
        }
      });
    },
    // 显示modal
    showAddModal(type, data) {
      this.showAddModalFlag = true;
      if (type === 'add') {
        // 新增
        this.addMenuModelInfo = {
          name: '',
          imgUrl: '',
          price: 0,
          desc: ''
        }
        this.submitType = "add"
      } else if (type === 'edit') {
        // 编辑
        this.addMenuModelInfo = {
          name: data.name,
          imgUrl: data.imgUrl,
          price: data.defaultUnitPrice,
          desc: data.describe !== 'null' ? data.describe : '',
          menuType: data.menuType,
          id: data.id
        }
        this.addMenuModelInfo.dinnerType = data.menuEatType !== null ? data.menuEatType.split(',').sort() : []
        this.addMenuModelInfo.menuLabel = data.label !== null ? data.label.split(',') : []

        this.submitType = "edit"
      }
      this.confirmLoading = false;
    },

    // 隐藏modal
    handleCancel() {
      this.showAddModalFlag = false;
    },
    // model提交
    handleSubmit(form, imgFile, imgState) {
      form.validateFields(
        (err, values) => {
          if (!err) {
            this.confirmLoading = true;
            let formData = new FormData();
            formData.append('name', values.name)
            formData.append('describe', values.desc)
            formData.append('defaultUnitPrice', values.price)
            formData.append('menuType', values.menuType)
            formData.append('type', values.dinnerType.join(','))
            formData.append('label', values.menuLabel.join(','))

            if (this.submitType === 'add') {
              formData.append('file', imgFile)
              addMenu(formData).then(res => {
                this.confirmLoading = false;
                if (res.data.state === 1) {
                  this.$message.success('添加成功');
                  this.showAddModalFlag = false;
                  // 清空表单
                  form.resetFields()
                  this.pagination.current = 1
                  this._getMenuList()
                }
              }, res => {
                this.confirmLoading = false;
              })
            } else {
              if (imgState) {
                formData.append('file', imgFile)
              } else {
                formData.append('file', '')
              }
              formData.append('id', values.id)
              editMenu(formData).then(res => {
                this.confirmLoading = false;
                if (res.data.state === 1) {
                  this.$message.success('修改成功');
                  this.showAddModalFlag = false;
                  // 清空表单
                  form.resetFields()
                  this._getMenuList()
                }
              }, res => {
                this.confirmLoading = false;
              })
            }
          }
        }
      );
    }
  },
  mounted() {
    // 获取列表
    this._getMenuList(this.pagination.current);
    this._getMenuType()
  },
  components: {
    addMenuModal,
    menuFoodDrawer
  },
  watch: {
    tabIndex: function (data) {
      if (data === '1') {
        this._getMenuList(this.pagination.current)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.table-page-search-wrapper {
  .ant-form-item {
    display: flex;
  }
}
.ant-form-item-control-wrapper {
  width: 100% !important;
}
.itemImgContent {
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 100%;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .itemTag {
    position: absolute;
    top: 0;
    right: 0;
    display: block;
    background-color: rgba(255, 255, 255, 0.6);
    padding: 0 10px;
    line-height: 1.8;
    color: #333;
    // border-left: 1px solid #e8e8e8;
    // border-bottom: 1px solid #e8e8e8;
  }
}

.menuListContent /deep/.ant-card-hoverable:hover {
  -webkit-box-shadow: 0 4px 10px rgba(0, 0, 0, 0.09);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.09);
  border-color: rgba(0, 0, 0, 0.09);
}
.menuListContent /deep/ .ant-card-body {
  padding: 0;
}
.menuListContent .ant-card-meta {
  text-align: center;
  line-height: 40px;
}
.menuListContent .ant-card-meta /deep/.ant-card-meta-title {
  font-size: 14px;
}
</style>
